import { PortalProductConfig, getProductWithVariants, ProductWithVariants } from '../../../models/product';
import { defaultContractWidgets } from '../../../config/default-contract-widgets';
import { InsuredInstrumentWidgetComponent } from '../widgets/insured-instrument-widget/insured-instrument-widget.component';

const portalConfig: PortalProductConfig = {
    icon: 'musician_pro',
    widgets: [...defaultContractWidgets, { component: InsuredInstrumentWidgetComponent }],
};

export const musikinstrumentenversicherungPremium: ProductWithVariants = getProductWithVariants({
    slug: 'musikinstrumentenversicherung',
    title: 'Musikinstrumentenversicherung Premium',
    fullTitle: 'Musikinstrumentenversicherung Premium',
    collapsableTitle: 'Musikinstrumenten&shy;versicherung Premium',
    insuranceTypeName: 'Musik',
    insuranceTypeId: 6,
    legacy: true,
    portalConfig,
});
